
import { Component, Vue } from "vue-property-decorator";
import { MedicalOrderService, EmployerActivityService } from "src/services";
import { Toast, Dialog } from "vant";
import dayjs from "dayjs";
import { CHECK_STATUS, ORDER_STATUS } from "src/enums";
import { Pay, tools } from "src/utils";
import RightsService from "src/services/rights-service";

@Component
export default class GoodsDetail extends Vue
{
    /**
     * 数据模型
     * @private
     * @returns any
     */
    private dataModel: any =
    {
        marketPrice: null,
        price: null,
        rightsId: null,
        rightsMainUrl: "",
        rightsName: "",
        storeId: null,
        storeLogo: "",
        storeName: "",
    };

    /**
     * 选择优惠券
     * @protected
     * @returns boolean
     */
    protected showCouponPopup: boolean = false;

    /**
     * 优惠券信息
     * @private
     * @returns any
     */
    private couponInfo: any =
    {
        finalReduceAmount: null,
        finalAmount: null,
        couponId: null,
    };

    /**
     * 可用优惠券列表
     * @private
     * @returns any
     */
    private couponList: any = [];

    /**
     * 商品详情id
     * @private
     * @returns string
     */
    private get id(): string
    {
        return this.$route.query && (this.$route.query.id as string) || "";
    }
    
    /**
     * 组件创建钩子
     * @protected
     * @returns void
     */
    protected created()
    {
        if(!localStorage.getItem("userInfo"))
        {
            this.$router.replace({name:"login", query:{redirect: location.href}});
            return;
        }
        this.getPreMedicalOrderInfo(this.id);
    }

    /**
     * 组件进来之前
     * @private
     * @returns void
     */
    private beforeRouteEnter(to, from, next): void
    {
        let appid = localStorage.getItem("appid");
        if (!tools.isAndroid() && `/${appid}${to.path}` !== location.pathname)
        {
           location.assign(`/${appid}${to.fullPath}`);
        }
        else
        {
            next();
        }
    }

    /**
     * 获取产品下单前数据
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getPreMedicalOrderInfo(id: string): Promise<void>
    {
        try
        {
            let {content: result} = await RightsService.instance.getRightsPreInfo(id);

            if(result.data)
            {
                this.dataModel = result.data;
                this.id && this.getCouponSuitable();
            }
        }
        catch(err)
        {
            Toast(JSON.stringify(err));
        }

    }

    /**
     * 提交订单
     * @public
     * @param {params}
     */
    public async onSubmit(): Promise<void>
    {
        try
        {
            let {content: result} = await RightsService.instance.createRightsOrder({ rightsId: this.id, couponId: this.couponInfo.couponId || null });
            
            if(result.data)
            {

                if(result.data.isNeedPay)
                {
                    // 需要支付
                    this.$router.push({name: "pay", query:{orderNo: result.data.orderNo}});
                }
                else
                {
                    this.$router.push({name: "rights-buy-success", query:{id: result.data.orderId}});
                }
            }

        }
        catch(err)
        {
            console.log(err,'err');
            Toast(JSON.stringify(err));
        }

    }

    /**
     * 跳转成功页面
     * @private
     * @returns void
     */
     private onSucessDetail(id: string): void
    {
        this.$router.push({name: "rights-buy-success", query:{id: id}});
    }

    /**
     * 跳转订单明细
     * @private
     * @returns void
     */
    private onActionOrderDetail(id: string): void
    {
        this.$router.push({name: "medical-order-detail", query:{id: id}});
    }

    /**
     * 获取优惠券列表
     * @private
     * @returns void
     */
     private async getCouponSuitable(): Promise<void>
    {
        try
        {
            let params = {
                id: this.id,
                isRights: true,
                amount: this.dataModel.price
            };
            let {content: result} =  await EmployerActivityService.instance.couponSuitable(params);

            if(result.data)
            {
                this.couponList = result.data;
                this.couponInfo = result.data[0] || {};
            }

        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 确认切换优惠券
     * @private
     * @returns void
     */
    protected onConfirmCoupon(data: any): void
    {
        if (data) {
            this.couponInfo = data;
        }
        else {
            this.couponInfo = {
                finalReduceAmount: null,
                finalAmount: null,
                couponId: null,
            };
        }
        this.showCouponPopup = false;
    }

}
